// styles.ts
import { SxProps, Theme } from '@mui/material';

export const styles: Record<string, SxProps<Theme>> = {
  container: {
    maxWidth: 600,
    margin: '0 auto',
    mt: 4,
    p: 3,
    border: '1px solid #ccc',
    borderRadius: 2,
  },
  title: {
    fontWeight: 'bold',
    mb: 2,
  },
  description: {
    mb: 3,
    color: 'text.secondary',
  },
  input: {
    mb: 2,
    width: '100%',
  },
  button: {
    mt: 2,
    backgroundColor: '#FFD814',
    color: '#000',
    fontWeight: 'bold',
    '&:hover': {
      backgroundColor: '#F7CA00',
    },
  },
};
